var map = {
	"./black/kongxian.png": "Ibiv",
	"./blue/kongxian.png": "Nw+4",
	"./white/kongxian.png": "kMyi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35Pz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/kongxian\.png$
// module id = 35Pz
// module chunks = 24